// editor strings (en). Card editor surface (src/layouts/CreateCardLayout).
const editor = {
	editor: {
		// Header / top toolbar
		backToDashboard: 'Back to dashboard',

		// Image merge tags (image tool panel)
		imageMergeTagTitle: 'Replace with merge tag',
		imageMergeTagHelp: "Each recipient sees the image URL from this tag. If it's empty or invalid, this image is shown.",
		imageMergeTagSelect: 'Select tag',
		imageMergeTagNew: '+ New tag',

		// Workspace default last page notice (below the pages)
		lastPageNotice: "This card ends with your workspace's default last page.",
		lastPageEditInSettings: 'Edit it in Settings',
		lastPageHideOnCard: 'Hide on this card',
		cardTitlePlaceholder: 'Card title',
		previewCard: 'Preview card',
		invite: 'Invite',
		sendCard: 'Send card',
		saveChanges: 'Save changes',

		// Left sidebar tool labels
		badgeNew: 'NEW',
		changeCover: 'Change Cover',
		coverType: 'Cover',
		coverStatic: 'Static image',
		coverDynamic: 'Dynamic',
		coverStaticConfirm: 'Switch to a static cover? Text, logos and merge tags on the cover will be removed.',
		coverRemoveImage: 'Remove cover image',
		addMessage: 'Add Message',
		addImage: 'Add Image',
		aiImage: 'AI Image',
		background: 'Background',
		addGif: 'Add GIF',
		addVideo: 'Add Video',
		music: 'Music',
		callToAction: 'Call-to-Action',

		// Autosave notification
		autosaveSaving: 'Saving ...',
		autosaveSaved: 'Autosaved',
		autosaveError: 'Autosave error!',
		close: 'Close',

		// Font tool
		chooseColor: 'Choose color',
		selectFont: 'Select Font',
		showMore: 'Show more',
		showLess: 'Show less',

		// Text effect tool
		effects: 'Effects',
		fontStyles: 'Font Styles',
		effectNone: 'None',
		effectHollow: 'Hollow',
		effectLift: 'Lift',
		effectShadow: 'Shadow',
		effectNeon: 'Neon',
		effectGlitch: 'Glitch',
		effectSplice: 'Splice',
		backToFontTool: 'Back to Font Tool',

		// Image tool
		searchPhotos: 'Search photos',
		search: 'Search',
		designOnCanva: 'Design on Canva',
		uploadImage: 'Upload Image',
		uploading: 'Uploading...',

		// GIF tool
		searchUpload: 'Search / Upload',
		embedLink: 'Embed Link',
		searchGifs: 'Search GIFs',
		uploadGif: 'Upload Gif',
		trending: 'Trending',
		pasteGifUrl: 'Paste GIF URL here...',
		loading: 'Loading...',
		addGifButton: 'Add GIF',
		gifUrlHint: 'Paste a direct link to a GIF file (ending in .gif) or a supported image URL.',

		// Video tool
		videoTabAdd: 'Add Video',
		videoTabRecord: 'Record',
		videoTabMyVideos: 'My Videos',
		videoAddHint: 'Paste a YouTube, Vimeo or direct video URL, or upload a video file.',
		videoUrlPlaceholder: 'https://...',
		add: 'Add',
		uploadVideo: 'Upload Video',
		videoSupportedHint: 'Supported: YouTube, Vimeo, MP4/WebM uploads.',
		noVideosUploaded: 'No videos uploaded yet.',
		confirmDeleteVideo: 'Are you sure you want to delete this video?',
		videoPreview: 'Video Preview',
		deleteSelectedVideo: 'Delete Selected Video',

		// Music tool
		musicUploaded: 'Uploaded',
		musicLibrary: 'Library',
		musicUpload: 'Upload',
		searchTracks: 'Search tracks...',
		loadingTracks: 'Loading tracks...',
		noTracksFound: 'No tracks found',
		dropAudioHere: 'Drop audio file here',
		audioFormats: 'MP3, WAV, or OGG',
		moodHappy: 'Happy',
		moodSad: 'Sad',
		moodRelaxing: 'Relaxing',
		moodEnergetic: 'Energetic',
		moodRomantic: 'Romantic',
		moodEpic: 'Epic',
		moodChill: 'Chill',
		moodUplifting: 'Uplifting',

		// Call to action panel
		createCta: 'Create a call-to-action',
		buttonLink: 'Button link (URL)',
		buttonText: 'Button text',
		buttonColor: 'Button color',
		textColor: 'Text color',
		borderStyle: 'Border style',

		// Video card sidebar panel
		videoCard: 'Video Card',
		videoCardIntro:
			'Design your card cover, then share the invite link so contributors can record or upload their video messages.',
		shareInviteLink: 'Share Invite Link',
		shareInviteLinkHint: "Copy this link and send it to anyone you'd like to contribute a video to this card.",
		linkCopied: 'Link Copied!',
		copyInviteLink: 'Copy Invite Link',
		howItWorks: 'How it works',
		videoCardStep1: 'Design your card cover and pages using the editor',
		videoCardStep2: 'Save and copy the invite link to share with contributors',
		videoCardStep3: 'Contributors record or upload videos via the link',
		videoCardStep4: 'Go to Video Cards dashboard to configure settings, review submissions, render & send',
		videoCardManageHint: 'Manage submissions, set deadlines, reorder videos, and render the final video from the',
		videoCardsDashboard: 'Video Cards',

		// Merge tags panel
		createWorkflowTitle: 'Create workflow with integrations',
		beta: 'Beta',
		createWorkflowDesc:
			'Connect your apps in minutes. Build any workflow you dream up with Zapier or Pabbly Connect. Automate your processes and integrate with your favorite apps to get more focus and less frustration.',
		createZapierWorkflow: 'Create Zapier Workflow',
		createPabblyWorkflow: 'Create Pabbly Connect Workflow',
		or: 'OR',
		sendViaEmailPlatform: 'Send via your email platform',
		personalisedLinkDesc:
			'Get a personalised link with merge tags formatted for your email platform (SendGrid, Brevo, HubSpot, Mailchimp).',
		getPersonalisedLink: 'Get Personalised Link',
		getEmbedCode: 'Get Email Embed Code',
		customizeAndSendBulk: 'Customize and send to bulk',
		customizeAndSendBulkDesc:
			'With %{app} you can personalize your cards. Create one card and send to all of your contacts using merge tags.',
		uploadCsv: 'Upload CSV',
		selectFromLists: 'SELECT FROM LISTS',
		clearAll: 'Clear all',
		noCsvUploaded: "You haven't uploaded a csv file yet. Get started by uploading a file from your device.",
		deleteCsv: 'Delete CSV',

		// Upload CSV modal
		uploadCsvTitle: 'Upload your CSV file here',
		uploadCsvDesc:
			'Once you upload your CSV, %{app} will map your data with the available merge tags along with custom tags for you to personalize each card and send cards to as many contacts you want',
		cancel: 'Cancel',
		next: 'Next',

		// Invite collaborators panel
		backToMain: 'Back to main',
		inviteCollaborators: 'Invite Collaborators',
		tabDirectLink: 'Direct Link',
		tabEmail: 'Email',
		tabSocial: 'Social',

		// Text fallback / merge tag toolbar
		mergeTags: 'Merge tags',
		newMergeTag: 'New merge tag',
		fromSource: 'From %{source}',
		csv: 'csv',
		// Card format + invitation event tool
		format: {
			tool: 'Format & event',
			title: 'Card format',
			single: 'Single page',
			singleDesc: 'One page, no flipping.',
			double: 'Front & back',
			doubleDesc: 'Two pages: a front and a back.',
			folded: 'Folded card (4 pages)',
			foldedDesc: 'Classic multi-page card.',
			front: 'Front',
			back: 'Back',
			card: 'Card',
			pageLimit: 'This card format allows at most %{max} page(s).',
			tooManyPages: 'This card has more pages than a %{max}-page format allows. Delete some pages first.',
		},
		event: {
			toggle: 'This card is an invitation',
			eventTitle: 'Event title',
			start: 'Starts',
			end: 'Ends (optional)',
			timezone: 'Timezone',
			inPerson: 'In person',
			online: 'Online',
			address: 'Address',
			hostNote: 'Note from the host',
			allowGuests: 'Allow guests (+1s)',
			save: 'Save invitation',
			saved: 'Invitation saved',
			errorTitle: 'Error',
			saveFailed: 'Could not save changes',
			errors: {
				titleRequired: 'Enter an event title.',
				titleTooLong: 'The title must be 200 characters or fewer.',
				startRequired: 'Choose a start date and time.',
				endInvalid: 'Enter a valid end date and time.',
				endBeforeStart: 'The end must not be before the start.',
				timezoneInvalid: 'Choose a valid timezone.',
				urlInvalid: 'Enter a valid http(s) link.',
				hostNoteTooLong: 'The note must be 1000 characters or fewer.',
			},
		},
	} as Record<string, any>,
};
export default editor;
